// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IntegrationDetailsModal-module__integrationDetailsModal___29AHb{width:580px}", "",{"version":3,"sources":["webpack://./src/redesign/pages/IntegrationsPage/components/modals/IntegrationDetailsModal/IntegrationDetailsModal.module.scss"],"names":[],"mappings":"AAAA,iEACE,WAAA","sourcesContent":[".integrationDetailsModal {\n  width: 580px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"integrationDetailsModal": "IntegrationDetailsModal-module__integrationDetailsModal___29AHb"
};
export default ___CSS_LOADER_EXPORT___;
